import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { Action } from '../../../actions';
import { EditorType } from '../constants';
import { isEditorOpened } from './utils';
import { Api } from '../../../typings/api';
import ApiUtils from '../../../utils/api';

export enum ThumbnailsActionKeys {
	SET_THUMBNAILS = '@@editor/thumbnails/SET_THUMBNAILS',
	SET_THUMBNAIL_VERSION = '@@editor/thumbnails/SET_THUMBNAIL_VERSION',
	SET_THUMBNAILS_TO_UPDATE = '@@editor/thumbnails/SET_THUMBNAILS_TO_UPDATE',
	TOGGLE_THUMBNAILS = '@@editor/thumbnails/TOGGLE_THUMBNAILS',
	SET_THUMBNAILS_WIDTH = '@@editor/thumbnails/SET_THUMBNAILS_WIDTH',
}

interface SetThumbnailsAction extends Action {
	type: ThumbnailsActionKeys.SET_THUMBNAILS;
	data: Api.EditorThumbnailData[];
}

interface SetThumbnailVersionAction extends Action {
	type: ThumbnailsActionKeys.SET_THUMBNAIL_VERSION;
	positions: number[];
	version: number;
}

interface SetThumbnailsToUpdateAction extends Action {
	type: ThumbnailsActionKeys.SET_THUMBNAILS_TO_UPDATE;
	positions: number[] | null;
}

interface ToggleThumbnailsAction extends Action {
	type: ThumbnailsActionKeys.TOGGLE_THUMBNAILS;
}

interface SetThumbnailsWidthAction extends Action {
	type: ThumbnailsActionKeys.SET_THUMBNAILS_WIDTH;
	width: number;
}

export type ThumbnailsAction =
	SetThumbnailsAction |
	SetThumbnailVersionAction |
	SetThumbnailsToUpdateAction |
	ToggleThumbnailsAction |
	SetThumbnailsWidthAction;

export const setThumbnails = (data: Api.EditorThumbnailData[]): SetThumbnailsAction => ({
	type: ThumbnailsActionKeys.SET_THUMBNAILS,
	data,
});

const setThumbnailVersion = (positions: number[], version: number): SetThumbnailVersionAction => ({
	type: ThumbnailsActionKeys.SET_THUMBNAIL_VERSION,
	positions,
	version,
});

export const setThumbnailsToUpdate = (positions: number[] | null): SetThumbnailsToUpdateAction => ({
	type: ThumbnailsActionKeys.SET_THUMBNAILS_TO_UPDATE,
	positions,
});

export const updateThumbnailsIfNeeded = (clientId: number, resourceId: number) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const {
			editor: {
				type,
				thumbnails: { positionsToUpdate },
			}
		} = getState();

		if (!positionsToUpdate || type !== EditorType.INDESIGN) {
			return;
		}

		if (isEditorOpened()) {
			await ApiUtils.reprocessPublicationThumbs(clientId, resourceId);
			dispatch(setThumbnailVersion(positionsToUpdate, Date.now()));
			dispatch(setThumbnailsToUpdate(null));
		} else {
			// do not need to wait response as editor is closed
			ApiUtils.reprocessPublicationThumbs(clientId, resourceId);
			dispatch(setThumbnailsToUpdate(null));
		}
	} catch (error) {
		// do not need to display any error message if reprocess is failed on server
	}
};

export const toggleThumbnails = (): ToggleThumbnailsAction => ({
	type: ThumbnailsActionKeys.TOGGLE_THUMBNAILS,
});

export const setThumbnailsWidth = (width: number): SetThumbnailsWidthAction => ({
	type: ThumbnailsActionKeys.SET_THUMBNAILS_WIDTH,
	width,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/actions/thumbnails.ts